import { render, staticRenderFns } from "./CreateScheme.vue?vue&type=template&id=71a855bb&scoped=true"
import script from "./CreateScheme.vue?vue&type=script&lang=js"
export * from "./CreateScheme.vue?vue&type=script&lang=js"
import style0 from "./CreateScheme.vue?vue&type=style&index=0&id=71a855bb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a855bb",
  null
  
)

export default component.exports